module.exports = __webpack_public_path__ + "img/arrow.e5fc3edd.svg";